module.exports = __webpack_public_path__ + "assets/img/cca7e9bf1209dcc3cc589542cd3810aa.png";